module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/cv_3_pc_cfae165701677d41be1d0e0c9e6f4b99.jpg";